module.exports = __webpack_public_path__ + "static/media/check-stats.2afe8acf.svg";